import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { portalAction } from 'root/redux/action/portal.action';

const TRANSACTION_TYPE = 'bettingSummary';

const DATERANGES = [
    'transaction:transaction.history.filter.today',
    'transaction:transaction.history.filter.3days',
    'transaction:transaction.history.filter.aweek',
    'transaction:transaction.history.filter.amonth',
];

//TODO: correct and check actual adata for the render()
const COLUMNS = [
    {
        key: 'gameProvider',
        render: (data, t, customTranslation) => t(customTranslation && data.provider in customTranslation ? customTranslation[data.provider]:  `providerName:ProviderName.${data.provider}`)
    },
    {
        key: 'betCount',
        render: (data) => data?.totalBet,
    },
    {
        key: 'betAmount',
        render: (data) => data.totalTurnOver,
    },
    {
        key: 'validBetAmount',
        render: (data) => data.totalValidTurnOver,
    },
    {
        //`${data.currency === 'KHUSD' ? 'USD' : data.currency} ${window.SPL_Other.formatAmount(data.bonusTurnover)}`,
        key: 'bonusTurnover',
        render: (data) => data.totalPromoTurnOver,
    },
    {
        key: 'turnoverWithoutBonus',
        render: (data) =>`${data.turnoverWithoutBonus}`,
    },
    {
        key: 'totalBonus',
        render: (data) => `${data.totalBonus}`,
    },
    {
        key: 'totalRebate',
        render: (data) => `${data.totalRebate}`,
    },
];

const getInitialRangeDate = () => {
    const timeRange = 6 * 24 * 3600000;
    const endDate = new Date();
    const startDate = new Date(endDate.getTime() - timeRange);

    return { startDate, endDate };
};

const useBettingSummary = () => {
    const [customTranslation, setCustomTranslation] = useState([])
    const [bettingSummary, setBettingSummary] = useState([]);
    const [sorting, setSorting] = useState({ createdDate: 'DESC' });
    const [rangeDate, setRangeDate] = useState(getInitialRangeDate());
    const [selectedDateRange, setSelectedDateRange] = useState(2);
    const [paging, setPaging] = useState({ currentPage: 1, itemPerPage: 5, totalCount: 0, totalPage: 0 });
    const language = useSelector((s) => s.language);
    const dispatch = useDispatch();
    const isMobile = useSelector((s)=> s.screen.viewType === 'mobile')

    const { currentPage, itemPerPage, totalPage, totalCount } = paging;
    const { startDate, endDate } = rangeDate;

    useEffect(() => {
        getCustomTranslation();
        getBettingSummary();
    }, [sorting, currentPage]);

    let datepickerLanguage = '';
    if (language.countryLanguageKey === 'TH_TH') {
        datepickerLanguage = 'th';
    } else if (language.countryLanguageKey === 'ZH_MY') {
        datepickerLanguage = 'zhCN';
    }

    const getCustomTranslation = () =>{
        window.SPL_Content.getCustomTranslation().then((data)=>{
            //forcefully use transfer en because it has all the providers there
            setCustomTranslation(data.transfer['ALL']['en']);
        })
    }

    const getBettingSummary = () => {
        dispatch(portalAction.portalIsLoading(true));

        const sort = Object.entries(sorting)
            .map(([k, v]) => `${k},${v.toUpperCase()}`)
            .join(';');

        const params = {
            start: new Date(startDate).toISOString(), //forcefully using new Date() whether first time loading or datepicker
            end: new Date(endDate).toISOString(),
            page: currentPage,
            size: itemPerPage,
            sort,
            isMobile:isMobile
        };
      
        try {
            window.SPL_Transaction.loadHistories(TRANSACTION_TYPE, params)
                .then((data) => {
                    setBettingSummary(data.histories)
                    let totalCount = data.headers['x-total-count']
                    let totalPage=  Math.ceil(totalCount / itemPerPage)
                    setPaging({
                        ...paging,
                        totalCount:totalCount,
                        totalPage: totalPage
                       
                    });
                    dispatch
                    (portalAction.portalIsLoading(false));
                })
                .catch((err) => {
                    dispatch(portalAction.portalIsLoading(false));
                })
                .finally(() => dispatch(portalAction.portalIsLoading(false)));
        } catch (e) {
            dispatch(portalAction.portalIsLoading(false));
        }
    };

    const handleDateChanged = (date, isStartDate) => {
        const newRangeDate = { ...rangeDate };
        if (isStartDate) {
            newRangeDate.startDate = date;
        } else {
            newRangeDate.endDate = date;
        }
        setRangeDate(newRangeDate);
    };

    const handlePrevNextClick = (isPrev, firstLast) => {
        if (firstLast) {
            if (firstLast === 'first') {
                handlePageClick(1);
            } else {
                handlePageClick(totalPage);
            }
        } else {
            if (isPrev) {
                handlePageClick(currentPage - 1);
            } else {
                handlePageClick(currentPage + 1);
            }
        }
    };

    const handlePageClick = (newPageNum) => {
        if (!(currentPage === newPageNum || newPageNum === 0 || newPageNum > totalPage)) {
            setPaging({ ...paging, currentPage: newPageNum });
        }
    };

    const sortSummary = (key) => {
        const newSorting = {};
        if (sorting[key] === 'DESC') {
            //TODO: change 'createdDate' into key
            newSorting['createdDate'] = 'ASC';
        } else {
            //TODO: change 'createdDate' into key
            newSorting['createdDate'] = 'DESC';
        }
        setSorting(newSorting);
    };

    const handleDateRange = (type) => {
        const newRangeDate = { ...rangeDate, endDate: new Date() };

        switch (type) {
            case 0:
                newRangeDate.startDate = new Date(newRangeDate.endDate.getTime());
                break;
            case 1:
                newRangeDate.startDate = new Date(newRangeDate.endDate.getTime() - 2 * 24 * 3600000);
                break;
            case 2:
                newRangeDate.startDate = new Date(newRangeDate.endDate.getTime() - 6 * 24 * 3600000);
                break;
            case 3:
                newRangeDate.startDate = new Date(newRangeDate.endDate.getTime() - 30 * 24 * 3600000);
                break;
            default:
                break;
        }

        setSelectedDateRange(type);
        setRangeDate(newRangeDate);
    };

    const pagingList = useMemo(() => {
        const { currentPage, totalPage } = paging;
        const list = [];
        for (let i = 0; i < totalPage; i++) {
            list.push({ pageNum: i + 1, active: currentPage === i });
        }

        return list;
    }, [currentPage, totalPage]);

    return {
        COLUMNS,
        DATERANGES,
        datepickerLanguage,
        selectedDateRange,
        currentPage,
        itemPerPage,
        totalPage,
        totalCount,
        pagingList,
        bettingSummary,
        startDate,
        endDate,
        sorting,
        customTranslation,
        getBettingSummary,
        handleDateRange,
        handleDateChanged,
        handlePageClick,
        handlePrevNextClick,
        sortSummary,
    };
};

export default useBettingSummary;
